import React, { useCallback, useState } from 'react';
import { Box, Button, TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import moment from "moment";
import request from "../../../utils/request";
import { AgGridReact } from "ag-grid-react";
import translations from "../../../utils/translations";
import { Form, Modal } from '@douyinfe/semi-ui';
import axios from "axios";
import header from "../../../layout/MainLayout/Header";
import QRCode from 'qrcode.react';

const UserOrderInfo = ({ userinfo }) => {
    const { register, handleSubmit } = useForm({
        defaultValues: {
            begintime: '1999-01-01',
            endtime: moment(new Date()).format('YYYY-MM-DD'),
        }
    })
    const [list, setlist] = useState([])
    const initData = JSON.parse(localStorage.getItem('initData'))
    const loginuser = JSON.parse(localStorage.getItem('userinfo'))
    const new_goodslist = JSON.parse(localStorage.getItem('new_goodslist'))
    const gridRef = React.useRef(null);
    const [qrCodeVisible, setQrCodeVisible] = useState(false)
    const [qrCodeUrl, setQrCodeUrl] = useState('')

    // 获取主订单状态的辅助函数
    const getMainOrderState = (suborders) => {
        if (!suborders || suborders.length === 0) return ''
        
        // 检查是否所有子订单都是取消状态
        const allCancelled = suborders.every(suborder => suborder.state === '取消')
        if (allCancelled) return '取消'
        
        // 如果不是全部取消，返回第一个非取消状态的子订单状态
        const activeSuborder = suborders.find(suborder => suborder.state !== '取消')
        return activeSuborder ? activeSuborder.state : suborders[0].state
    }
    return (
        <Box border={1} p={1} mt={3} borderColor="#ccc">
            <Box>
                <Form labelPosition="inset" layout="horizontal" onSubmit={async data => {
                    const rew = await request('post', '/api/getInfo', {
                        userid: userinfo.userid,
                        url: 'Srapp.Web_User_Infos.UserOrderInfo',
                        distributionstore: '全部',
                        department: '全部',
                        // state: JSON.stringify(["正常", "已安排", "已接单", "已送达", "已收瓶", "取消"]),
                        begintime: moment(data.date[0]).format('YYYY-MM-DD'),
                        endtime: moment(data.date[1]).format('YYYY-MM-DD'),
                        date: undefined,
                        goodsids: JSON.stringify(data.goodsids),
                    })
                    // rew.data 按照 addtime 倒序
                    rew.data.sort((a, b) => {
                        return new Date(b.addtime) - new Date(a.addtime)
                    })
                    setlist(rew.data)
                }}>
                    <Form.DatePicker label="日期" field="date" initValue={['1999-01-01', new Date()]} type="dateRange" presets={[
                        {
                            text: '最近一周',
                            end: new Date(),
                            start: moment().subtract(7, 'days').toDate(),

                        },
                        {
                            text: '最近三个月',
                            end: new Date(),
                            start: moment().subtract(3, 'months').toDate(),
                        },
                        {
                            text: '最近一年',
                            end: new Date(),
                            start: moment().subtract(1, 'years').toDate(),
                        }
                    ]} />
                    <Form.TreeSelect label="商品" field="goodsids" multiple filterTreeNode leafOnly treeData={new_goodslist} maxTagCount={1} />
                    <Button size="small" type="submit" sx={{ ml: 1 }} variant="contained">搜索</Button>
                </Form>
            </Box>
            <Box height="50vh" overflow="scroll" marginTop={2}>
                <AgGridReact
                    ref={gridRef}
                    defaultColDef={{
                        resizable: true,
                        sortable: true,
                        filter: 'agTextColumnFilter',
                        floatingFilter: true,
                    }}
                    className="ag-theme-balham"
                    getRowStyle={params => {
                        if (params.data) {
                            const mainOrderState = getMainOrderState(params.data.suborder)
                            
                            if (mainOrderState === '已安排') {
                                return { color: "red" }
                            }
                            if (mainOrderState === '已送达') {
                                return { color: "blue" }
                            }
                            if (mainOrderState === '已接单') {
                                return { color: "green" }
                            }
                            if (mainOrderState === '取消') {
                                return { color: "pink" }
                            }
                        }
                        return { color: "black" }
                    }}
                    onFirstDataRendered={params => params.api.sizeColumnsToFit()}
                    columnDefs={[
                        {
                            field: 'addtime', headerName: '日期', enableRowGroup: true, hide: true,
                            valueGetter: data => data.data ? moment(data.data.addtime).format('MM-DD') : '',

                        },
                        {
                            field: 'addtime', headerName: '下单时间', enableRowGroup: true,
                            valueGetter: data => data.data ? moment(data.data.addtime).format('YYYY-MM-DD HH:mm') : '',
                            cellRenderer: 'agGroupCellRenderer'
                        },

                        {
                            field: 'appointmenttime', headerName: '预约上门时间', enableRowGroup: true,
                            valueGetter: data => data.data ? moment(data.data.appointmenttime).format('YYYY-MM-DD HH:mm') : ''
                        },

                        {
                            field: 'id', headerName: '商品',
                            enableRowGroup: true,
                            valueGetter: (params) => {
                                let str = ''
                                if (params.data) {
                                    for (let i = 0; i < params.data.suborder.length; i += 1) {
                                        str += (`${params.data.suborder[i].goodsname}X${params.data.suborder[i].num} `)

                                    }
                                }
                                return str
                            }
                        },
                        { field: 'memberid', headerName: '会员号', enableRowGroup: true },
                        {
                            field: 'department', headerName: '门店', enableRowGroup: true,
                            valueGetter: params => params.data ? params?.data?.suborder[0]?.department : '',
                        },
                        { field: 'name', headerName: '联系人', enableRowGroup: true },
                        { field: 'telephone', headerName: '联系人电话', enableRowGroup: true },
                        { field: 'address', headerName: '地址', enableRowGroup: true },
                        { field: 'balance', headerName: '交易后余额', enableRowGroup: true },
                        { field: 'primary_balance', headerName: '交易前余额', enableRowGroup: true },
                        {
                            field: 'deliveryman', headerName: '配送员', enableRowGroup: true,
                            valueGetter: params => params.data ? params?.data?.suborder[0]?.deliveryman : ''
                        },
                        { field: 'booking_operator', headerName: '预约人', enableRowGroup: true },

                        {
                            field: 'payment',
                            headerName: '支付方式',
                            enableRowGroup: true,
                            valueGetter: params => params.data ? params?.data?.suborder[0]?.payment : '',

                        },
                        {
                            field: 'suborder', enableRowGroup: true, headerName: '状态', valueGetter: (params) => {
                                if (params.data) {
                                    return getMainOrderState(params.data.suborder)
                                }
                                return ''
                            }
                        },
                        { field: 'remarks', headerName: '备注', enableRowGroup: true },
                        { field: 'ope_remarks', headerName: '内部备注', enableRowGroup: true },
                        { field: 'ope_remarks', headerName: '送达时间', enableRowGroup: true, valueGetter: ({ data }) => data?.suborder[0]?.arrivetime },
                        { field: 'ope_remarks', headerName: '打印时间', enableRowGroup: true, valueGetter: ({ data }) => data?.suborder[0]?.arrangetime },
                        { headerName: '电子订单',cellRendererFramework:({data}) => getMainOrderState(data?.suborder) === '已送达' && <Button onClick={async ()=>{
                            const rew = await axios.post('https://sdapiweb.sanrangas.com/ElectronicOrdersInfo',{
                                companyid: data.companyid,
                                userid: data.userid,
                                serial: data.serial_main,
                            }, {
                                headers: {
                                    'clientType': 'mini'
                                },
                                'clientType': 'mini'
                            })

                            // 生成二维码弹窗展示
                            setQrCodeUrl(rew.data.url)
                            setQrCodeVisible(true)
                            }}>生成</Button>},

                    ]}
                    masterDetail="true"
                    embedFullWidthRows="true"
                    detailRowAutoHeight="true"

                    detailCellRendererParams={{
                        detailGridOptions: {
                            columnDefs: [
                                { field: 'arrangetime', headerName: '打印时间', width: 100 },
                                { field: 'arrivetime', headerName: '送达时间', width: 100 },
                                { field: 'distributionmode', headerName: '派单模式', width: 100 },
                                { field: 'goodsname', headerName: '商品名称', width: 100 },
                                { field: 'num', headerName: '数量', width: 100 },
                                { field: 'total', headerName: '小计', width: 100 },
                                { field: 'mode', headerName: '模式', width: 100 },
                                { field: 'pay_arrears', headerName: '月结支付', width: 100 },
                                { field: 'pay_balance', headerName: '余额支付', width: 100 },
                                { field: 'pay_cash', headerName: '现金支付', width: 100 },
                                { field: 'pay_cashgift', headerName: '现金券支付', width: 100 },
                                { field: 'pay_coupon', headerName: '优惠券支付', width: 100 },
                                { field: 'pay_online', headerName: '在线支付', width: 100 },
                                { field: 'pay_stock', headerName: '库存支付', width: 100 },
                                { field: 'department', headerName: '订单部门', width: 100 },
                                { field: 'cancel_department', headerName: '取消部门', width: 100 },
                                { field: 'cancel_operator', headerName: '取消操作员', width: 100 },
                                { field: 'cancel_remarks', headerName: '取消备注', width: 100 },
                                { field: 'cancel_time', headerName: '取消时间', width: 100 },
                                { field: 'state', headerName: '子订单状态', width: 100 },
                            ],
                            defaultColDef: {

                                resizable: true
                            },
                        },
                        getDetailRowData: (params) => {
                            console.log(gridRef)
                            params.successCallback(params.data.suborder);
                        },

                    }}


                    rowData={list}

                    localeText={translations}


                />
            </Box>
            
            {/* 二维码弹窗 */}
            <Modal 
                visible={qrCodeVisible} 
                title="二维码" 
                onCancel={() => setQrCodeVisible(false)}
                footer={null}
                style={{ top: '10%' }}
            >
                <Box display="flex" flexDirection="column" pb={3} alignItems="center" gap={2}>
                    {qrCodeUrl && (
                        <>
                            <QRCode value={qrCodeUrl} size={200} />
                            <Button 
                                variant="contained" 
                                onClick={() => window.open(qrCodeUrl)}
                                style={{ marginTop: '16px' }}
                            >
                                点击查看
                            </Button>
                        </>
                    )}
                </Box>
            </Modal>

        </Box>
    );
};

export default UserOrderInfo;
